import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-border bg-transparent hover:bg-muted hover:border-primary/50 text-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-muted hover:text-foreground text-muted-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        nav: "bg-primary text-primary-foreground hover:bg-primary/90 font-medium",
        // Primary CTA - Electric Indigo with glow
        cta: "bg-primary text-primary-foreground hover:bg-primary/90 shadow-glow hover:shadow-glow-lg hover:scale-[1.02] font-semibold border border-primary/20",
        // Glass outline button for secondary CTAs
        glass: "bg-transparent border border-border/50 backdrop-blur-lg text-foreground hover:bg-muted/50 hover:border-primary/40 hover:shadow-glow font-medium",
        // Gold accent for featured items
        gold: "bg-gradient-to-r from-[hsl(var(--gold))] to-[hsl(var(--gold-glow))] text-background hover:opacity-90 shadow-glow-gold font-semibold",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-9 px-4",
        lg: "h-12 px-8 text-base",
        xl: "h-14 px-10 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
